import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  loadingStarted(state) {
    state.loadingStatus = true;
  },
  loadingFinished(state) {
    state.loadingStatus = false;
  },
  signInSuccess(state, payload) {
    state.partnerUser = payload.partnerUser;
  },
  updateUser(state, payload) {
    state.partnerUser = payload.partnerUser;
  },
  updateContracts(state, payload) {
    state.availableContracts = payload.availableContracts;
    state.expiredContracts = payload.expiredContracts;
  },
  passwordReissue(state, payload) {
    state.passwordReissue.email = payload.email;
  },
  passwordReset(state, payload) {
    state.passwordReset = payload;
  },
  scoutPlan(state, payload) {
    state.scoutPlan = payload;
  },
  savedSearchOptionCount(state, payload) {
    state.savedSearchOptionCount = payload;
  },
  changeMenuType(state, payload) {
    state.menuType = payload;
  }
};

export default mutations;
